import {ModalBody, ModalFooter, ModalHeader} from "@heroui/modal";
import {Button} from "@heroui/button";
import React, {useEffect} from "react";
import {useMonitoring} from "@/components/monitoring";
import {Chip} from "@heroui/chip";
import {Bold} from './Bold'
import {Card, CardBody} from "@heroui/card";
import {STARTER_PACK_PRICE, STARTER_PACK_DOWNLOAD_CREDITS, formatPrice} from "@/config/pricing";
import {UpsellVodPreview} from "@/components/DownloaderApp/UpsellVodPreview";
import {UpsellPopupVariant1} from "@/components/DownloaderApp/UpsellPopupVariant1";

function IconBxExtension(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path
                d="M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v3.881l.659.239C4.461 11.41 5 12.166 5 13s-.539 1.59-1.341 1.88L3 15.119V19c0 1.103.897 2 2 2h3.881l.239-.659C9.41 19.539 10.166 19 11 19s1.59.539 1.88 1.341l.239.659H17c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4h-2l-.003 5h-2.545c-.711-1.22-2.022-2-3.452-2s-2.741.78-3.452 2H5v-2.548C6.22 15.741 7 14.43 7 13s-.78-2.741-2-3.452V7h5V5a1 1 0 012 0v2h5v5h2a1 1 0 010 2z"/>
        </svg>
    );
}

function Plan({ title, price, recommended, credits, features }) {
    return (<Card className={`flex-grow ${recommended? "border border-gray-700" : ""}`}>
        <div className={"mx-4 my-5 flex flex-col text-left gap-2"}>
            <span className={`text-2xl ${recommended ? "font-bold": ""}`}>{title}</span>
            <span><Bold className={"text-2xl font-bold"}> ${price}</Bold>
                <span className={"text-sm text-gray-400"}> / one-time payment</span>
            </span>
            <b className={"text-sm"}>
                {recommended ? (<Bold>{credits} Sub-only </Bold> ) : (<>{credits} Sub-only </> )}

                download credits</b>
        </div>

        <CardBody>
            <ul className={"gap-2 my-3 flex flex-col text-left text-sm"}>
                {(features ?? []).map((feature, i) => (
                    <li key={i} className={"flex items-center gap-2"}><OutlineCheckCircle /> {feature}</li>
                ))}
            </ul>
        </CardBody>
        <Button className={"mx-5 my-4"} color="secondary" variant={recommended ? undefined : "flat"}
                startContent={<PremiumSvgIcon/>}>
            {/*Start downloading Subs-only VODs*/}
            Get started
        </Button>
    </Card>)
}


const PremiumSvgIcon = (props) => (<svg width="32" height="32" viewBox="0 0 32 32" {...props} fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="size-3 ml-2 shrink-0 grow-0">
    <path
        d="M17.4999 11.2575L18.6459 13.7338C19.1794 14.8888 20.1067 15.8163 21.2613 16.3501L23.7369 17.4876L21.2613 18.6339C20.1067 19.1676 19.1794 20.0952 18.6459 21.2502L17.4999 23.7265L16.354 21.2502C15.8204 20.0952 14.8932 19.1676 13.7386 18.6339L11.263 17.4876L13.7386 16.3413C14.8932 15.8076 15.8204 14.8801 16.354 13.7338L17.4999 11.2575ZM17.4999 4.9924L13.9747 12.6313C13.7036 13.2175 13.2312 13.6901 12.6451 13.9613L5.00863 17.4876L12.6539 21.0139C13.24 21.2852 13.7123 21.7577 13.9835 22.3439L17.5087 29.9828L21.0339 22.3439C21.3051 21.7577 21.7774 21.2852 22.3635 21.0139L30 17.4876L22.3635 13.9613C21.7774 13.6901 21.3051 13.2175 21.0339 12.6313L17.5087 4.9924H17.4999Z"></path>
    <path
        d="M7.37091 2L5.85761 5.29006C5.74389 5.54381 5.5427 5.74506 5.28903 5.85882L2 7.37259L5.28903 8.88637C5.5427 9.00012 5.74389 9.20137 5.85761 9.45513L7.37091 12.7364L8.88422 9.44638C8.99793 9.19262 9.19912 8.99137 9.4528 8.87762L12.7418 7.36384L9.4528 5.85007C9.19912 5.73631 8.99793 5.53506 8.88422 5.28131L7.37091 2Z"></path>
</svg>)

export function showUpsellModal(show, data = {}) {
    const isVariant1 = data.isVariant1 ?? false;
    return show({
        component: isVariant1 ? UpsellPopupVariant1 : UpsellPopup,
        data: {
            vodId: data.vodId || null,
            source: data.source || 'direct-download',
            isExternal: data.isExternal ?? false,
            vodUrl: data.vodUrl ?? '',
            scrollBehavior: "inside",
            className: isVariant1 ? "" : "min-h-2/5",
            size: isVariant1 ? '3xl' : '4xl',
        },
    })
}

export function showUpsellModal2(show, data = {}) {
    return show({
        component: UpsellPopup2,
        data: {
            vodId: data.vodId || null,
            source: data.source || 'direct-download',
            isExternal: data.isExternal ?? false,
            vodUrl: data.vodUrl ?? '',
            scrollBehavior: "inside",
            className: "min-h-2/5",
            size: '4xl',
        },
    })
}

export function OutlineCheckCircle(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="20px"
            height="20px"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4l8-8z"
            ></path>
        </svg>
    )
}


export function UpsellPopup(props) {
    return <UpsellPopupBase {...props} variant="original"/>;
}

export function UpsellPopup2(props) {
    return <UpsellPopupBase {...props} variant="conversion"/>;
}

function UpsellPopupBase({data, onClose, variant}) {
    const {track} = useMonitoring()


    const [isLoading, setIsLoading] = React.useState(false)
    const contextVodId = null

    useEffect(() => {
        track('UpsellPopup opened', {
            source: data.source
        })
    }, []);

    useEffect(() => {
        try {
            window.posthog?.startSessionRecording();
        } catch (err) {
        }

        return () => {
            try {
                window.posthog?.stopSessionRecording();
            } catch (err) {
            }
        }
    }, []);

    let CTA_LINK = `https://kick-video-download.lemonsqueezy.com/buy/0a65e7f8-7959-437e-b613-0547d366fb0a?discount=1`;
    CTA_LINK = `/api/stripe/checkout?platform=kick${data.vodUrl ? `&vodUrl=${data.vodUrl}`: ''}`;

    function onPressed() {
        track('[Premium] UpsellPopup > CTA clicked', {
            source: data.source
        });
        setIsLoading(true);
        if(data.isExternal) {
            window.open(CTA_LINK);
            onClose();
        } else {
            window.location.href = CTA_LINK;
        }

    }

    const starterPackFeatures = [
        (<span><Bold>$0,25</Bold> / VOD ({STARTER_PACK_DOWNLOAD_CREDITS} credits)</span>),
        <span>Works with every Kick creator</span>,
        <span>One-time payment, no recurring costs</span>,
        <span>No hidden fees, no surprises</span>
    ]
    const fanPackFeatures = [
        (<span><Bold>$0,20</Bold> / VOD (30 credits)</span>),
        <span>Works with every Kick creator</span>,
        <span>One-time payment, no recurring costs</span>,
        <span>No hidden fees, no surprises</span>
    ]

    if (variant === 'original') {
        return (
            <>
                <ModalHeader className="flex flex-col gap-1">
                    <span id="modal-title"></span>
                </ModalHeader>
                <ModalBody className="my-2">
                    <div className="flex flex-col justify-center items-center h-full gap-10 my-5">
                        <div className="flex flex-col gap-1">
                            <b className="text-xl text-center">
                                Unlock <Bold> Subscription-only</Bold> Kick VODs Without a Monthly Subscription
                            </b>
                        </div>

                        <b className="text-2xl">
                            Get <Bold>{STARTER_PACK_DOWNLOAD_CREDITS} download credits</Bold> for just{' '}
                            <Bold>{formatPrice(STARTER_PACK_PRICE)} 🎉</Bold>
                        </b>

                        <div className="flex flex-col-reverse md:flex-row gap-6 items-center">
                            <div className={`${data.vodId ? 'md:basis-2/3' : ''} flex items-center`}>
                                <div className="flex flex-col gap-2">
                                    <span className="text-sm">Benefits:</span>
                                    <ul className="gap-2 flex flex-col text-left text-sm">
                                        <li className="flex items-start gap-2">
                                            <OutlineCheckCircle className="shrink-0 mt-0.5" style={{color: '#51fc1a'}}/>
                                            <span>
                                                <Bold>Significant Savings:</Bold> {STARTER_PACK_DOWNLOAD_CREDITS} download credits ={' '}
                                                {STARTER_PACK_DOWNLOAD_CREDITS} subscription-only VODs
                                            </span>
                                        </li>
                                        <li className="flex items-start gap-2">
                                            <OutlineCheckCircle className="shrink-0 mt-0.5" style={{color: '#51fc1a'}}/>
                                            <span><Bold>Zero Commitment:</Bold> One-time payment. Absolutely no recurring fees</span>
                                        </li>
                                        <li className="flex items-start gap-2">
                                            <OutlineCheckCircle className="shrink-0 mt-0.5" style={{color: '#51fc1a'}}/>
                                            <span><Bold>Flexible:</Bold> Credits stay valid for 3 full months</span>
                                        </li>
                                        <li className="flex items-start gap-2">
                                            <OutlineCheckCircle className="shrink-0 mt-0.5" style={{color: '#51fc1a'}}/>
                                            <span><Bold>Fair Play:</Bold> Re-downloading the same video never costs extra</span>
                                        </li>
                                        <li className="flex items-start gap-2">
                                            <OutlineCheckCircle className="shrink-0 mt-0.5" style={{color: '#51fc1a'}}/>
                                            <span><Bold>VOD Player included:</Bold> no need to download whole video</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <UpsellVodPreview
                                variant="original"
                                vodId={data.vodId}
                                vodUrl={data.vodUrl}
                            />
                        </div>

                        <div className="flex flex-row gap-4 items-center">
                            <Button
                                isDisabled={isLoading}
                                isLoading={isLoading}
                                onPress={onPressed}
                                color="secondary"
                                startContent={<PremiumSvgIcon/>}
                            >
                                <span>Unlock Access ({formatPrice(STARTER_PACK_PRICE)})</span>
                            </Button>
                            {!contextVodId ? null : (
                                <Button
                                    isDisabled={isLoading}
                                    isLoading={isLoading}
                                    onPress={() => window.open(`/api/get-premium-content-sample?uuid=${contextVodId}`)}
                                    color="default"
                                >
                                    <span>Download this VOD FREE sample (10 seconds)</span>
                                </Button>
                            )}
                        </div>
                    </div>
                </ModalBody>
            </>
        );
    }

    return (
        <>
            <ModalHeader className="flex flex-col items-center gap-3 px-6 pb-0 pt-6 text-center">
                <Chip
                    color="secondary"
                    radius="sm"
                    size="sm"
                    startContent={<PremiumSvgIcon/>}
                    variant="flat"
                >
                    KICK SUB-ONLY VODS
                </Chip>
                <h2 id="modal-title" className="max-w-2xl text-2xl font-bold leading-tight sm:text-3xl">
                    Unlock subscription-only VODs without another monthly subscription
                </h2>
                <p className="max-w-xl text-sm font-normal text-neutral-400 sm:text-base">
                    One payment gives you {STARTER_PACK_DOWNLOAD_CREDITS} download credits for any Kick creator.
                </p>
            </ModalHeader>
            <ModalBody className="px-4 pb-6 pt-5 sm:px-6">
                {
                    false ? (<>
                            <span className={"text-center text-xl font-bold"}>Get your <Bold>Sub-Only</Bold> Video download credits 🎉</span>
                        <div className={"my-5 flex flex-row gap-5"}>
                            <Plan features={starterPackFeatures} credits={STARTER_PACK_DOWNLOAD_CREDITS} price={STARTER_PACK_PRICE} title={"Starter Pack"}></Plan>
                            <Plan features={fanPackFeatures} recommended credits={<Bold>25 + 5</Bold>} price={5.99} title={"Fan Pack"}></Plan>
                        </div>

                    <p className={"my-5 mx-5 text-center text-sm italic"}>"Unique content should be more accessible. Download it before it's deleted"</p>
                    </> ): (
            <div className="mx-auto flex w-full max-w-3xl flex-col gap-5">
                <div className={`grid gap-5 rounded-2xl border border-white/10 bg-white/[0.03] p-4 sm:p-5 ${data.vodId ? 'md:grid-cols-[240px_1fr]' : ''}`}>
                    <UpsellVodPreview
                        variant="conversion"
                        vodId={data.vodId}
                        vodUrl={data.vodUrl}
                    />
                    <div className="flex flex-col justify-center">
                        <p className="mb-3 text-sm font-semibold text-white">Everything you need to keep the VODs you care about</p>
                        <ul className="flex flex-col gap-3 text-sm text-neutral-300">
                            <li className="flex items-start gap-2.5">
                                <OutlineCheckCircle className="mt-0.5 shrink-0 text-[#51fc1a]"/>
                                <span><b className="text-white">{STARTER_PACK_DOWNLOAD_CREDITS} VOD downloads</b> from any Kick creator</span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <OutlineCheckCircle className="mt-0.5 shrink-0 text-[#51fc1a]"/>
                                <span><b className="text-white">No recurring fees</b> — pay once, use credits for 3 months</span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <OutlineCheckCircle className="mt-0.5 shrink-0 text-[#51fc1a]"/>
                                <span><b className="text-white">Built-in VOD player</b> — watch without downloading the entire video</span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <OutlineCheckCircle className="mt-0.5 shrink-0 text-[#51fc1a]"/>
                                <span>Download the same VOD again without using another credit</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="rounded-2xl border border-secondary/30 bg-secondary/10 p-4 sm:p-5">
                    <div className="mb-4 flex items-end justify-between gap-4">
                        <div>
                            <p className="text-sm text-neutral-300">Starter Pack · one-time payment</p>
                            <p className="mt-1 text-sm font-medium text-white">{STARTER_PACK_DOWNLOAD_CREDITS} download credits</p>
                        </div>
                        <div className="text-right">
                            <p className="text-3xl font-bold text-white">{formatPrice(STARTER_PACK_PRICE)}</p>
                            <p className="text-xs text-neutral-400">No subscription</p>
                        </div>
                    </div>
                    <Button
                        className="w-full font-semibold"
                        color="secondary"
                        isDisabled={isLoading}
                        isLoading={isLoading}
                        onPress={onPressed}
                        size="lg"
                        startContent={<PremiumSvgIcon/>}
                    >
                        <span>Get {STARTER_PACK_DOWNLOAD_CREDITS} Download Credits</span>
                    </Button>
                    <p className="mt-3 text-center text-xs text-neutral-400">
                        Secure checkout · Credits are ready after payment
                    </p>
                </div>
            </div>
                    )
                }
            </ModalBody>
            {/*<ModalFooter>*/}
            {/*    <Button onPress={openInstallExtension} color="primary"*/}
            {/*            startContent={<IconBxExtension width={"20px"} height={"20px"}/>}>*/}
            {/*        Install extension*/}
            {/*    </Button>*/}
            {/*    <Button onPress={onClose}>*/}
            {/*        Close*/}
            {/*    </Button>*/}
            {/*</ModalFooter>*/}
        </>
    );
}